import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addEndingSequence, selectReaderManager, clearEndingSequence, replaceEndingSequence } from '../../ReaderManagerEvents/ReaderManagerSlice';
/**
 * this hook is used to play the ending speech of the phrase by putting it into
 * the reader manager's events redux store a string, the reader manager will
 * check if there is a speech string in the store and play it before it when the 
 * phrase ends.
 */
export default function useEndingSpeech() {

    const dispatch = useDispatch();
    const { contextStates } = useSelector(selectReaderManager);
    const { endingSequence } = contextStates;

    const [ hasPendingEndingSequence, setHasPendingEndingSequence ] = useState(!!endingSequence.length);

    useEffect(() => {
        if(endingSequence.length){
            setHasPendingEndingSequence(true);
        } else {
            setHasPendingEndingSequence(false);
        }
    }, [endingSequence]);

    const addToEndingSequence = (payload) => {
        dispatch(addEndingSequence(payload));
    };

    const replaceTheEndingSequence = (payload) => {
        dispatch(replaceEndingSequence(payload));
    };

    return {
        addToEndingSequence,
        replaceTheEndingSequence,
        hasPendingEndingSequence,
    };
}